import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "@/components/site/ScrollToTop";
import Landing from "@/pages/Landing";
import WhoWeAre from "@/pages/about/WhoWeAre";
import PortfolioCompanies from "@/pages/about/PortfolioCompanies";
import Leadership from "@/pages/about/Leadership";
import Careers from "@/pages/about/Careers";
import Investments from "@/pages/Investments";
import InvestmentApproach from "@/pages/investments/InvestmentApproach";
import InvestmentFramework from "@/pages/investments/InvestmentFramework";
import PortfolioComposition from "@/pages/investments/PortfolioComposition";
import InvestmentEvolution from "@/pages/investments/InvestmentEvolution";
import Platforms from "@/pages/Platforms";
import PortfolioAssets from "@/pages/PortfolioAssets";
import CommunityEducation from "@/pages/CommunityEducation";
import SearchResults from "@/pages/SearchResults";
import LegalPage from "@/pages/LegalPage";
import Insights from "@/pages/Insights";
import Contact from "@/pages/Contact";
import AssetDetail from "@/pages/AssetDetail";
import CompanyDetail from "@/pages/CompanyDetail";
import LeaderDetail from "@/pages/LeaderDetail";
import BlogArticle from "@/pages/BlogArticle";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<Navigate to="/about/who-we-are" replace />} />
          <Route path="/about/who-we-are" element={<WhoWeAre />} />
          <Route path="/about/what-we-do" element={<Navigate to="/about/who-we-are" replace />} />
          <Route path="/about/portfolio-companies" element={<PortfolioCompanies />} />
          <Route path="/about/leadership" element={<Leadership />} />
          <Route path="/about/careers" element={<Careers />} />
          <Route path="/investments" element={<Navigate to="/investments/approach" replace />} />
          <Route path="/investments/approach" element={<InvestmentApproach />} />
          <Route path="/investments/framework" element={<InvestmentFramework />} />
          <Route path="/investments/composition" element={<PortfolioComposition />} />
          <Route path="/investments/evolution" element={<InvestmentEvolution />} />
          <Route path="/investments/full" element={<Investments />} />
          <Route path="/investments/platforms" element={<Platforms />} />
          <Route path="/investments/portfolio-assets" element={<PortfolioAssets />} />
          <Route path="/impact" element={<CommunityEducation />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<BlogArticle />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/privacy-policy" element={<LegalPage variant="privacy" />} />
          <Route path="/terms-of-use" element={<LegalPage variant="terms" />} />
          <Route path="/asset/:slug" element={<AssetDetail />} />
          <Route path="/portfolio/:slug" element={<CompanyDetail />} />
          <Route path="/leadership/:slug" element={<LeaderDetail />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
